import { IsNotEmpty, IsDefined } from 'class-validator';

import { EntityModel } from 'src/core/services/data/models';
import { DataService, property } from 'src/core/services/data.service';
import { BookemZulu as Model } from 'src/core/services/data/JayDataContext';

export class AgentBrandDataService extends DataService<typeof Model.Bookings.Logic.ViewModels.AgentBrandItem, Model.Bookings.Logic.ViewModels.AgentBrandItem, AgentBrandItem> {
	protected map(entity: Model.Bookings.Logic.ViewModels.AgentBrandItem): AgentBrandItem {
		return new AgentBrandItemModel(entity);
	}

	private id = -1;
	static make(ctx?: any): AgentBrandDataService {
		return new AgentBrandDataService(ctx, ctx => ctx.AgentBrands, false);
	}

	add(agent: AgentItem): Promise<AgentBrandItem> {
		const entity = new Model.Bookings.Logic.ViewModels.AgentBrandItem();
		if (agent.id > 0) {
			entity.agentId = agent.id;
		} else {
			entity.agent = agent.entity;
		}
		entity.id = this.id--;

		return this.create(() => entity);
	}
}

export class AgentBrandItemModel extends EntityModel<Model.Bookings.Logic.ViewModels.AgentBrandItem, AgentBrandItem> implements AgentBrandItem {
	@property<AgentBrandItemModel>(o => o.entity.id, (o, value) => o.entity.id = value)
	public id: number;

	@property<AgentBrandItemModel>(o => o.entity.agentId, (o, value) => o.entity.agentId = value)
	//@IsDefined({ message: "agent is required" })
	public agentId: number;

	@property<AgentBrandItemModel>(o => o.entity.brandId, (o, value) => o.entity.brandId = value)
	@IsDefined({ message: 'Brand is required' })
	public brandId: number;

	@property<AgentBrandItemModel>(o => o.entity.brandName, (o, value) => o.entity.brandName = value)
	@IsDefined({ message: 'BrandName is required' })
	public brandName: string;
}



// WEBPACK FOOTER //
// ./src/app/bookings/agent-brands/agent-brand-form.data.ts